import { useTranslation } from "react-i18next";
import Text from "../../../molecules/content/Text";
import Accordion from "../../accordion/Accordion";
import { getCountryCode } from "../../../../helpers/utils";
import ContactContent from "../../../molecules/contactContent/ContactContent";

const FAQSection = ({ items }) => {
  const { t } = useTranslation();
  const countryCode = getCountryCode();

  return (
    <div className="flex flex-col gap-4">
      <Text variant="h2" className="flex lg:justify-center text-vestelColor">
        {t("support.title")}
      </Text>
      <div className="flex flex-col-reverse md:flex-col lg:flex-col gap-4">
        <ContactContent countryCode={countryCode} />
        <Text
          variant="semibold"
          className="flex justify-center text-vestelColor"
        >
          {t("support.description")}
        </Text>
        <Accordion items={items} />
      </div>
    </div>
  );
};

export default FAQSection;
